import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Observable } from 'rxjs';
import { AppConfig } from '../../helper/config/api.config';
import { ClientAppLogout } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(
    private dataProvider: DataService
  ) { }

  getUserAuthenticatedDetails(params: any): Observable<any> {
    ClientAppLogout();
    return this.dataProvider.Post<any>(AppConfig.Validate, params);
  }
}
